export namespace MessagingEvents {
  export enum EPageEvents {
    REDIRECT_EVENT = 'spa:redirect',
  }

  export enum ECartManipulationEvents {
    CART_UPDATE_EVENT = 'header:cart:overview:update',
  }
}
